import type { ApiKey, CreateApiKeyResponse } from '@mp-pro/shared/interfaces';
import { MPAPISlice } from './ModelParkAPI';

export const ApiKeyAPI = MPAPISlice.injectEndpoints({
    endpoints: builder => ({
        getApiKeys: builder.query<ApiKey[], string>({
            query: appName => ({ url: `app-project/${appName}/api-keys` }),
            providesTags: (_result, _error, appName) => [{ type: 'ApiKeys', id: appName }],
        }),

        createApiKey: builder.mutation<CreateApiKeyResponse, { appName: string; name: string; expiresAt?: string }>({
            query: ({ appName, ...body }) => ({
                url: `app-project/${appName}/api-keys`,
                method: 'POST',
                body,
            }),
            invalidatesTags: (_result, _error, { appName }) => [{ type: 'ApiKeys', id: appName }],
        }),

        revokeApiKey: builder.mutation<void, { appName: string; keyId: string }>({
            query: ({ appName, keyId }) => ({
                url: `app-project/${appName}/api-keys/${keyId}`,
                method: 'DELETE',
            }),
            invalidatesTags: (_result, _error, { appName }) => [{ type: 'ApiKeys', id: appName }],
        }),
    }),
});

export const {
    useGetApiKeysQuery,
    useCreateApiKeyMutation,
    useRevokeApiKeyMutation,
} = ApiKeyAPI;
